import { SpaceMemberRole } from './space';

export enum ProjectMemberRole {
    VIEWER = 'viewer',
    INTERACTIVE_VIEWER = 'interactive_viewer',
    MARKETER = 'marketer',
    EDITOR = 'editor',
    DEVELOPER = 'developer',
    ADMIN = 'admin',
    SUPPORT = 'support',
}
export const ProjectMemberRoleDescription: Record<ProjectMemberRole, string> = {
    [ProjectMemberRole.VIEWER]: 'View-only access to this workspace',
    [ProjectMemberRole.INTERACTIVE_VIEWER]: '',
    [ProjectMemberRole.MARKETER]:
        'Editor who cannot access data and SQL interfaces',
    [ProjectMemberRole.EDITOR]:
        'Creates and modifies entities in this workspace',
    [ProjectMemberRole.DEVELOPER]: '',
    [ProjectMemberRole.ADMIN]: 'Manages this workspace',
    [ProjectMemberRole.SUPPORT]:
        'Views user profiles and manages subscription preferences',
};
export const ProjectMemberRoleLabels: Record<ProjectMemberRole, string> = {
    [ProjectMemberRole.VIEWER]: 'Viewer',
    [ProjectMemberRole.INTERACTIVE_VIEWER]: 'Interactive Viewer',
    [ProjectMemberRole.MARKETER]: 'Marketer',
    [ProjectMemberRole.EDITOR]: 'Editor',
    [ProjectMemberRole.DEVELOPER]: 'Developer',
    [ProjectMemberRole.ADMIN]: 'Admin',
    [ProjectMemberRole.SUPPORT]: 'Support',
} as const;

export type OrganizationRole = {
    type: 'organization';
    role: ProjectMemberRole | undefined;
};

export type ProjectRole = {
    type: 'project';
    role: ProjectMemberRole | undefined;
};

export type GroupRole = {
    type: 'group';
    role: ProjectMemberRole | undefined;
};

export type SpaceGroupAccessRole = {
    type: 'space_group';
    role: ProjectMemberRole | undefined;
};

export type InheritedRoles = [OrganizationRole, GroupRole, ProjectRole];

const RoleTypes = ['organization', 'project', 'group', 'space_group'] as const;

export type RoleType = (typeof RoleTypes)[number];

export type InheritedProjectRole = {
    type: RoleType;
    role: ProjectMemberRole;
};

export const ProjectRoleOrder = {
    [ProjectMemberRole.VIEWER]: 0,
    [ProjectMemberRole.INTERACTIVE_VIEWER]: 1,
    [ProjectMemberRole.EDITOR]: 2,
    [ProjectMemberRole.DEVELOPER]: 3,
    [ProjectMemberRole.ADMIN]: 4,
    [ProjectMemberRole.MARKETER]: 5,
    // SUPPORT has the lowest precedence to avoid ambiguity with VIEWER (0)
    [ProjectMemberRole.SUPPORT]: -1,
} as const;

export const SpaceRoleOrder = {
    [SpaceMemberRole.VIEWER]: 0,
    [SpaceMemberRole.EDITOR]: 1,
    [SpaceMemberRole.ADMIN]: 2,
} as const;
